module.exports = __webpack_public_path__ + "static/media/blog.290cb14b.png";